import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a42980"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-border" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "menu-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首页", -1))
const _hoisted_5 = { class: "menu-items" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解决方案", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "操作指南", -1))
const _hoisted_8 = { class: "menu-items" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最新活动", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关于我们", -1))

import { ref } from 'vue';
import { useRoute,useRouter } from 'vue-router';
import {
    Shop,
    Menu,
    Present,
    Setting,
    Avatar,
    Fold,
    Expand,
    ArrowRight
} from '@element-plus/icons-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'newMenu',
  setup(__props) {

let router = useRouter();
let route = useRoute();
let isIon = ref(false);
let openMenu = () => {
    isIon.value = !isIon.value;
}
let open1 = ref(true);
let open2 = ref(true);
let openPage = (url:string,index:number) => {
    if(index === 0 && url != 'url'){
        router.push(url);
        isIon.value = !isIon.value;
    }
    if(index === 1 && url == 'url'){
        open1.value = !open1.value;
        open2.value = true;
    }
    if(index === 2 && url == 'url'){
        open2.value = !open2.value;
        open1.value = true;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_popup, {
        show: _unref(isIon),
        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (_isRef(isIon) ? (isIon).value = $event : isIon = $event)),
        position: "left",
        style: { width: '55%', height: '100%' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("section", {
              class: _normalizeClass({'menu-L':true, 'menu-G' : _unref(isIon)}),
              style: {}
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({'menu-item':true,'textColor':_unref(route).name == 'home'}),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openPage)('/',0)))
              }, [
                _createElementVNode("p", null, [
                  _createVNode(_component_el_icon, { class: "iconT" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Shop))
                    ]),
                    _: 1
                  }),
                  _hoisted_4
                ])
              ], 2),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("section", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(openPage)('url',1))),
                  class: _normalizeClass({'menu-items-father':true,
                                'textColor':_unref(route).name == 'broadcast' || _unref(route).name == 'chatGPT'})
                }, [
                  _createElementVNode("p", null, [
                    _createVNode(_component_el_icon, { class: "iconT" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Menu))
                      ]),
                      _: 1
                    }),
                    _hoisted_6
                  ]),
                  _createElementVNode("p", null, [
                    _createVNode(_component_el_icon, {
                      style: _normalizeStyle(_unref(open1) ? '' : 'transform: rotate(90deg);'),
                      class: "iconT"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowRight))
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ])
                ], 2),
                _createElementVNode("section", {
                  class: "menu-items-child",
                  style: _normalizeStyle(_unref(open1) ? 'height:0px;' : '')
                }, [
                  _createElementVNode("p", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(openPage)('/broadcast',0))),
                    class: _normalizeClass({'color':_unref(route).name == 'broadcast'})
                  }, "跨境电商直播", 2),
                  _createElementVNode("p", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(openPage)('/chatGPT',0))),
                    class: _normalizeClass({'color':_unref(route).name == 'chatGPT'})
                  }, "chartGPT", 2)
                ], 4)
              ]),
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(openPage)('/guide',0))),
                class: _normalizeClass({'menu-item':true,'textColor':_unref(route).name == 'guide'})
              }, [
                _createElementVNode("p", null, [
                  _createVNode(_component_el_icon, { class: "iconT" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Setting))
                    ]),
                    _: 1
                  }),
                  _hoisted_7
                ])
              ], 2),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("section", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(openPage)('url',2))),
                  class: _normalizeClass({'menu-items-father':true,
                                'textColor':_unref(route).name == 'newActivity'})
                }, [
                  _createElementVNode("p", null, [
                    _createVNode(_component_el_icon, { class: "iconT" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Present))
                      ]),
                      _: 1
                    }),
                    _hoisted_9
                  ]),
                  _createElementVNode("p", null, [
                    _createVNode(_component_el_icon, {
                      style: _normalizeStyle(_unref(open2) ? '' : 'transform: rotate(90deg);'),
                      class: "iconT"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowRight))
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ])
                ], 2),
                _createElementVNode("section", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(openPage)('/newActivity',0))),
                  class: "menu-items-child",
                  style: _normalizeStyle(_unref(open2) ? 'height:0px;' : '')
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass({'color':_unref(route).name == 'newActivity'})
                  }, "跨境电商直播专线解决方案", 2)
                ], 4)
              ]),
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(openPage)('/about',0))),
                class: _normalizeClass({'menu-item':true,'textColor':_unref(route).name == 'about'})
              }, [
                _createElementVNode("p", null, [
                  _createVNode(_component_el_icon, { class: "iconT" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Avatar))
                    ]),
                    _: 1
                  }),
                  _hoisted_10
                ])
              ], 2)
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createElementVNode("div", {
      class: "anniu",
      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(openMenu) && _unref(openMenu)(...args)))
    }, [
      _withDirectives(_createVNode(_component_el_icon, {
        class: _normalizeClass(_unref(isIon) ? 'textColor' : '')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Expand))
        ]),
        _: 1
      }, 8, ["class"]), [
        [_vShow, _unref(isIon)]
      ]),
      _withDirectives(_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [
          _createVNode(_unref(Fold))
        ]),
        _: 1
      }, 512), [
        [_vShow, _unref(isIon) == false]
      ])
    ])
  ]))
}
}

})